import { RootState } from 'src/state/rootReducer';

export const getTags = (state: RootState) => state.entities.equipmentTags.tags;
